export default "__VITE_ASSET__d4f9ed7b__"